<template>
  <v-container fluid class="qmkey-menus-view">
    <v-row dense class="d-flex mb-0 pb-0" style="height: 50px">
      <!-- View Title -->
      <v-col class="d-flex mt-1 mb-0 pb-0 ml-2" md="auto">
        <ViewTitle title="Sites" />
      </v-col>
      <v-col class="d-flex mb-0 pb-0" >
        <v-btn
          rounded
          small
          class="add-button"
          @click.stop="addSiteForm()"
          >
            Add Site
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="sites"
      :headers="fields"
      dense
      item-class="qmkey-item-row"
    >
      <template v-slot:item.name="{ item }">
        <v-btn
          @click.stop="editSiteForm(item.id)"
          text
          small
          class="qmkey-add-button-menu"
        >
          {{ item.name }}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <!-- <v-btn
          small
          icon
          class="mr-2"
          @click.stop="editSiteForm(item.id)"
        >
         <v-icon >mdi-pencil</v-icon>
        </v-btn> -->
        <v-icon
          small
          class="mr-2"
          @click.stop="editSiteForm(item.id)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click="addSubSiteForm(item)"
        >
          mdi-plus
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteSiteForm(item.id)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <!-- Add /edit dialog -->
    <v-dialog max-width="600px" v-model="showEdit" persistent>
      <v-card
        class="mx-auto"
        :loading="loading">
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn
            text @click="close"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle 
          class="pb-0"
          v-if="modalSubTitle"
        >
          {{ modalSubTitle }}
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="editSite" v-model="valid" autocomplete="new-password">
            <v-alert
              :value="alert"
              color="error"
              dark
              icon="mdi-alert"
              transition="scale-transition"
              outlined              
            >
              {{ message }}
            </v-alert>
            <v-text-field
              id="sitename"
              v-model="currentSite.name"
              type="text"
              required
              placeholder="Enter Site Name"
              label="Site name"
              :rules="[rules.required]"
            ></v-text-field>
            <v-select
              :items="storage_types"
              v-model="currentSite.storage_type"
              required
              placeholder="Enter Sede Storage type"
              label="Storage type"
              :rules="[rules.required]"
            ></v-select>
            <v-text-field
              id="max_users_number"
              v-model="currentSite.max_users_number"
              type="number"
              required
              placeholder="Enter max. site users number"
              label="Max. Site users"
              :rules="[rules.required, numberRule]"
            ></v-text-field>
            <v-file-input
              id="sitelogo"
              label="Logo"
              placeholder="Pick logo"
              prepend-icon="mdi-camera"
              @change="previewImage"
              v-model="logo"
            ></v-file-input>
            <v-select
              :items="qmkey_product"
              v-model="currentSite.qmkey_product"
              required
              placeholder="Enter QMKey product"
              label="QMKey product"
              :rules="[rules.required]"
            ></v-select>
          </v-form>
          <v-img
            max-height="200px"
            max-width="200px"
            :src="getLogo"
          >
          </v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>          
          <v-btn
            class="mr-4"
            @click="processForm"
            :disabled="!valid"
          >
            Ok
          </v-btn>
          <v-btn @click="clear">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="500px" v-model="showDelete" persistent>
      <v-card
        class="mx-auto"
        :loading="loading"
        >
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
        </v-card-title>
        <v-card-text>
          Do you want to delete site 
          <strong>{{currentSite.name}}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" @click="processDelete">Ok</v-btn>
          <v-btn @click="showDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import Site from '@/api/Site'

export default {
  name: 'SitesView',
  components: {
    ViewTitle,
  },

  data() {
    return {
      currentSite: {},
      message: null,
      modalTitle: null,
      modalSubTitle: null,
      fields: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Path',
          sortable: true,
          value: 'path',
        },
        {
          text: 'Parent',
          sortable: true,
          value: 'parent',
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
        },
      ],
      alert: false,
      showEdit: false,
      loading: false,
      showDelete: false,
      rules: {
        required: value => !!value || "Required.",
      },
      storage_types: [
        {
          text: 'FileSystem',
          value: 'filesystem'
        },
        {
          value: 'dropbox',
          text: 'Dropbox'
        },
        {
          value: 'gdrive',
          text: 'GDrive'
        }
      ],
      qmkey_product: [
        {
          text: 'QmKey',
          value: 'qmkey',
        },
        {
          text: 'QmFood',
          value: 'qmfood',
        },
        {
          text: 'QmHealth',
          value: 'qmhealth',
        },
      ],
      logo_url:'',
      logo: null,
      valid: true,
      img_err: false,
    }
  },

   computed: {
    ...mapState(['sitePath', 'isLoading', 'sites']),
    getLogo(){
      if (this.logo_url) {
        return this.logo_url
      }
      else if (this.currentSite.logo){
        console.log('Warning harcoded url Sites.getLogo', this.currentSite.logo)
        return this.$base + this.currentSite.logo
      }
    },
  },

  methods: {
    addSiteForm() {
      this.currentSite = {storage_type: 'filesystem'}
      this.modalTitle = 'Add new site'
      this.showEdit = true
    },

    addSubSiteForm(parentSite) {
      this.currentSite = { parent: parentSite.id, storage_type: 'filesystem' }
      this.modalTitle = `Add new subsite for site #${parentSite.id}`
      this.modalSubTitle = `${parentSite.name}`
      this.showEdit = true
    },

    deleteSiteForm(id) {
      Site.get(this.sitePath, id)
        .then(response => {
          this.currentSite = response
          this.modalTitle = `Delete site #${id}`
          this.showDelete = true
        })
        .catch(err => {
          alert(err)
        })
    },

    editSiteForm(id) {
      this.message = null
      Site.get(this.sitePath, id)
        .then(response => {
          this.currentSite = response
          this.modalTitle = `Edit site #${id}`
          this.modalSubTitle = ''
          this.showEdit = true
          // this.logo = response.logo
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    addSite() {
      this.currentSite.logo = this.logo
      let edit_form = this.$refs.editSite.$el
      var form_data = new FormData()
      for ( var key in this.currentSite ) {
        if (this.currentSite[key] !=null){
          form_data.append(key, this.currentSite[key])
        }
      }
      Site.postSite(this.sitePath, form_data)
        .then(() => {
          this.GET_SITES(this.sitePath)
          this.GET_ALL_SITES(this.sitePath)
          this.showEdit = false
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    deleteSite() {
      Site.delete(this.sitePath, this.currentSite.id)
        .then(() => {
          this.GET_SITES(this.sitePath)
          this.GET_ALL_SITES(this.sitePath)
          this.showDelete = false
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    updateSite() {
      this.currentSite.logo = this.logo
      let edit_form = this.$refs.editSite.$el
      var form_data = new FormData()
      for ( var key in this.currentSite ) {
        if (this.currentSite[key] !=null){
          form_data.append(key, this.currentSite[key])
        }
      }
      Site.putSite(this.sitePath, this.currentSite.id, form_data)
        .then(() => {
          this.GET_SITES(this.sitePath)
          this.GET_ALL_SITES(this.sitePath)
          // this.$refs.modal.hide()
          this.$refs.editSite.reset()
          this.message = ''
          this.alert = false
          this.showEdit = false
          this.logo_url = ''
          this.logo = null
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    processForm(evt) {
      if (evt) evt.preventDefault()
      // check if id already exists
      if (this.currentSite.id !== undefined) {
        this.updateSite()
      } else {
        this.addSite()
      }
    },

    processDelete(evt) {
      if (evt) evt.preventDefault()
      this.deleteSite()
    },
    ...mapActions(['GET_ALL_SITES', 'GET_SITES', 'GET_USERS']),
    ...mapMutations(['SET_CURRENT_SITE']),

    clear: function() {
        this.message = ''
        this.alert = false
        this.$refs.editSite.resetValidation()
        this.currentSite = {}
        this.logo_url = ''
        this.logo = null
    },
    close: function() {
      this.$refs.editSite.reset()
      this.message = ''
      this.alert = false
      this.showEdit = false
      this.logo_url = ''
      this.logo = null
    },
    previewImage(evt){
      console.log('previewImage', evt)
      if (evt) {
        this.logo_url = URL.createObjectURL(evt)
      }
      else{
        this.logo_url = ''
      }
    },
    numberRule: function(value) {
      if (!String(value).trim()) return true;
      if (!isNaN(parseFloat(value)) && value > 0) return true;
      return 'Number has to be greater than 0';
    },
    errorHandler(evt) {
      // TODO handle load err
      // this.previewImage("required('../assets/image_not_found.png')")
      this.img_err = true
    }
  },

  mounted: function() {
    this.GET_ALL_SITES(this.sitePath)
      .then(() => {
        this.SET_CURRENT_SITE(this.$session.get('site'))
        this.GET_SITES(this.sitePath)
      })
      .then(() => {
        this.GET_USERS(this.sitePath)
      })
  },
}
</script>


<style lang="scss">
  @import "@/sass/menus.scss";
</style>
